import { createSelector } from 'reselect';
import get from 'lodash.get';
import { insights } from 'services/api';
import produce from 'immer';
import { addOneToImmerState } from './util';

const RECEIVE_SHOW_STATS_FOLLOWERS = 'create/show/stats/followers';
const RECEIVE_SHOW_STATS_LISTENS = 'create/show/stats/listens';

const initialState = {
  items: {},
};
export default produce((state, action) => {
  switch (action.type) {
    case RECEIVE_SHOW_STATS_FOLLOWERS:
    case RECEIVE_SHOW_STATS_LISTENS:
      addOneToImmerState(state, action.payload);
      break;

    default:
      break;
  }
}, initialState);

const selectShowStats = state => get(state, ['v2', 'showStats'], null);
export const selectShowFollowerStats = showId =>
  createSelector(
    selectShowStats,
    stats => get(stats, ['items', showId, 'followers'])
  );
export const selectShowListenStats = showId =>
  createSelector(
    selectShowStats,
    stats => get(stats, ['items', showId, 'listens', 'total'])
  );

export const fetchShowFollowerStats = showId => dispatch => {
  return insights.get(`/api/v2/charts/followers/${showId}`).then(response => {
    dispatch({
      type: RECEIVE_SHOW_STATS_FOLLOWERS,
      payload: {
        id: showId,
        followers: response.body,
      },
    });
    return Promise.resolve();
  });
};

export const fetchShowListenStats = showId => dispatch => {
  return insights.get(`/api/v2/charts/overview/${showId}`).then(response => {
    dispatch({
      type: RECEIVE_SHOW_STATS_LISTENS,
      payload: {
        id: showId,
        listens: response.body,
      },
    });
    return Promise.resolve();
  });
};
